module.exports = "pegasus_template/assets/pexels-photo-2.png";